import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/idle_fees',
  component: Management,
  redirect: '/idle_fees/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/idle_fees/List'),
      meta: {
        auth: Auth.listIdleFees
      }
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/idle_fees/New'),
      meta: {
        auth: Auth.createIdleFee
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/idle_fees/Edit'),
      meta: {
        auth: Auth.updateIdleFee
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/idle_fees/DetailLayout'),
      meta: {
        auth: Auth.showIdleFee
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/idle_fees/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showIdleFee
          }
        },
        {
          path: 'idle_fee_bills',
          component: () => import('@/views/idle_fees/details/IdleFeeBills'),
          meta: {
            tabName: 'idle_fee_bills', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listIdleFeeBills
          }
        }
      ]
    }
  ]
}
